'use strict';
var exports = $.extend({}, require('base/login/login'));

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

module.exports = {
    callModal: function(){
        $('.js-change-customer').on('click', function(){
            var customerDataID = $(this).data('customernobtn');
            $('input[name="customerNo"]').val(customerDataID);
        });
    },
    customerLogin: function () {
        $('form.customerChildLogin').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            var hiddenInput = $('input[name="customerNo"]');
            var customerNo = hiddenInput.val();
            $('form.login').trigger('login:submit', e);

            var formData = {
                childCustomerId: customerNo
            }

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('form.customerChildLogin').trigger('login:error', data);
                    } else {
                        $('form.customerChildLogin').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    }
};
